import { Component, OnInit } from '@angular/core';
import { BomLine } from '../../api/models/bom-line';
import { ProjectService } from '../../api/services/project.services';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { CommentsAdapterService } from '../comments/comments-adapter.service';
import { Comment } from '../../api/models/comment';
import { Location } from '@angular/common';
import { BomTableService } from '../bom-table/bom-table.service';
import { Worksheet } from '../../api/models/worksheet';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DownloadCopyComponent } from '../order-worksheet/download-copy/download-copy.component';
import { UserService } from '../../api/services/user.service';
import { MarketBannerService } from '../market-banner/market-banner.service';
import { RoleRequest } from '../../api/models/role-assignment-map';
import { AuthService } from '../../api/services/auth.service';

@Component({
  selector: 'app-readonly-worksheet',
  templateUrl: './readonly-worksheet.component.html',
  styleUrls: ['./readonly-worksheet.component.scss'],
  providers: [BomTableService, CommentsAdapterService]
})
export class ReadonlyWorksheetComponent implements OnInit {

  completedOrder = true;

  worksheet: Worksheet;

  bomData: Observable<BomLine[]>;

  comments: Comment[];

  errorMessage: string[] = [];

  constructor(
    private marketBannerService: MarketBannerService,
    private userService: UserService,
    private projectService: ProjectService,
    private commentsAdapterService: CommentsAdapterService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private location: Location,
    private modalService: NgbModal,
    private authService: AuthService
  ) { }

  submitOrder() {
    this.router.navigate(['/checkout', { outlets: { 'checkout-content': ['review', this.worksheet.id] } }]);
  }

  openWarrantyForm(){
    this.router.navigate(['/dashboard', { outlets: { 'dashboard-content': ['warranty-claim', this.worksheet.id] } }]);
  }

  receiveGoods() {
    this.router.navigateByUrl('/');
  }

  openSaveEmailModal() {
    const modalRef = this.modalService.open(DownloadCopyComponent, {
      backdrop : 'static',
      keyboard : false
    });
    modalRef.componentInstance.worksheetId = this.worksheet.id;
  }

  goBack(): void {
    this.location.back();
  }

  ngOnInit() {
    this.activatedRoute
      .params.map(p => p.id)
      .subscribe(id => {
        this.projectService.getWorksheet(id)
          .subscribe(w => {
            if (this.userService.isMarketPermittedForCurrentUser(w.project.marketId)) {
              this.worksheet = w;
              this.marketBannerService.refreshMarketBanner();
              this.bomData = this.projectService.getBomLines(this.worksheet.bomId);
              this.authService.getUserRoles(new RoleRequest('ADMIN_TESSCO', null)).subscribe(roles => {
                let isTesscoAdmin = roles.getRoleMap('ADMIN_TESSCO');
                this.commentsAdapterService.getCommentsTree(`WORKSHEET~${id}`, isTesscoAdmin)
                  .subscribe(comments => this.comments = comments);
              });
            } else {
              this.worksheet = null;
              this.errorMessage.push("You don't have permission to view this page!!!");
            }
          });
      });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/readonly-worksheet/readonly-worksheet.component.ts